module.exports = __webpack_public_path__ + "img/jiaoyiguanli.13fdd40b.png";